module.exports = __webpack_public_path__ + "static/media/main idea.811785a5.mp3";